import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component((node, ctx) => {
  const drawerEl = node.querySelector('[data-drawer]');
  const drawer = Drawer(drawerEl, node);

  const denyTrigger = node.querySelector('[data-deny]');
  const acceptTrigger = node.querySelector('[data-accept]');

  drawer.on('opened', () => {
    node.classList.remove('pointer-events-auto');
  });

  drawer.on('closed', () => {
    node.classList.add('pointer-events-none');
  });

  ctx.on('terms:accept', ({ accept }) => {
    if (!accept) drawer.open();
    else drawer.close();
  });

  acceptTrigger.addEventListener('click', (e) => {
    e.preventDefault();

    ctx.emit('terms:accept', { accept: true });
    document.querySelector('button[name="checkout"]').click();
  });

  denyTrigger.addEventListener('click', (e) => {
    e.preventDefault();

    drawer.close();
  });
});
